import { IPlanContent } from '../typings/planContent.types';
import { defaultEstimatesDialog } from './common/planDefaults';

/**
 * This is a fallback for when no plan name is found.  Should never reach here in real life, but useful for some tests.
 */
export const fallbackContent: IPlanContent = {
  test: () => true,
  content: {
    rateDiscountText: {
      defaultState: {
        defaultFuel: 'Our 12 month fixed rates',
      },
    },
    uiOptions: {
      defaultState: {
        defaultFuel: {
          planColor: {
            text: {
              styleGuide: 'orange',
              odsCore: 'neutral',
            },
            promobox: {
              styleGuide: 'lightOrange',
              odsCore: 'neutral',
            },
            bannerText: {
              styleGuide: 'grey56',
              odsCore: 'neutralDark',
            },
          },
          imageUrl:
            'https://res.cloudinary.com/originenergy/image/upload/v1729663222/spot-illustrations/spot-default-plan.svg',
          imageForFuelType: {
            electricity:
              'https://www.originenergy.com.au/cdn/images/originenergy/image/upload/CP/plans/cp_default_elec.svg',
            gas: 'https://www.originenergy.com.au/cdn/images/originenergy/image/upload/CP/plans/cp_default_gas.svg',
            dual: 'https://www.originenergy.com.au/cdn/images/originenergy/image/upload/CP/plans/cp_default_dual.svg',
          },
        },
      },
    },
    termsAndConditionsUrl: {
      defaultState: {
        defaultFuel: '/terms-and-conditions.html',
      },
    },
    estimatesDialog: defaultEstimatesDialog(),
  },
};
